import { Component, inject } from '@angular/core';
import { SoftwareSpecificSearchService } from '../software-specific-search.service';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { KBLanguageService } from 'src/app/services/sapSpartacus/kbLanguageService/KbLang-service.service';

@Component({
  selector: 'app-kb-software-details-page',
  templateUrl: './kb-software-details-page.component.html',
  styleUrls: ['./kb-software-details-page.component.scss'],
  standalone: false
})
export class KbSoftwareDetailsPageComponent {
  private service = inject(SoftwareSpecificSearchService);
  private activatedroute = inject(ActivatedRoute);
  private langservice = inject(KBLanguageService);

  avoidPageLoadCall: boolean = false;
  private subsLang: Subscription;
  private apiSubs: Subscription;

  private code;
  apiData$ = new BehaviorSubject<any>(null);
  softwareCode: string;
  emailFlow: boolean;

  ngOnInit() {
    this.activatedroute.queryParamMap.subscribe((params) => {
      this.code = params.get('code');
      this.softwareCode = params.get('softwareCode');
      //if flow comes from Email we are having separate api call
      if (this.softwareCode) {
        this.emailApiCall();
        this.emailFlow = true;
      }
      else {
        this.apiCaller();
        this.emailFlow = false;
      }

    });

  }

  ngAfterViewInit() {
    this.subsLang = this.langservice.getActive().subscribe((lang: any) => {
      if (this.avoidPageLoadCall) {
        this.apiCaller();
      }
    });
  }

  apiCaller() {
    this.apiSubs = this.service.getSoftwareDetailsPage(this.code).subscribe((apiResponse: any) => {
      this.apiData$.next(apiResponse);
      this.avoidPageLoadCall = true;
    });
  }

  emailApiCall() {
    this.apiSubs = this.service.getSoftwareDetailsPageforEmail(this.softwareCode).subscribe((apiResponse: any) => {
      this.apiData$.next(apiResponse);
      this.avoidPageLoadCall = true;
    });
  }


  ngOnDestroy() {
    this.subsLang && this.subsLang.unsubscribe();
    this.apiSubs && this.subsLang.unsubscribe();
  }
}
